<template>
  <div>
    <Head title="Applicant Contact" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/view`">
        {{ data.applicant_id }}. {{ data.applicant_name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.treatment_id}/view`">{{data.treatment_type_name}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{$t('interventions.new')}}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <Form :form-data="form"
              :users="users"
              :intervention_types="intervention_types"
              :cooperations="cooperations"
              :locations="locations"
              :requests="requests"
              :treatment_type="data.treatment_type_name"
              :send_types="send_types"
              :seen_types="seen_types"
              :is-new="true">
        </Form>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{$t('global.create')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Form from './Form'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    Form
  },
  layout: Layout,
  props: {
    data: Object,
    users: Array,
    intervention_types: Array,
    cooperations: Array,
    locations: Object,
    requests: Array,
    send_types: Array,
    seen_types: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        notes: '',
        date: '',
        user_id: this.data.user_id,
        intervention_type_id: '',
        cooperation_id: '',
        location_id: '',
        request_ids: [],
        location_field: '',
        request_field: '',
        send_field: '',
        seen: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post(`/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/interventions/create`)
    }
  },
}
</script>
